import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { NzNotificationService } from 'ng-zorro-antd/notification'

import { environment } from '../../../environments/environment'
import { User } from '../../models/user.model'
import { CognitoService } from '../../services/cognito.service'
import { ButtonComponent } from '../button/button.component'

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    SvgIconComponent,
    RouterLink,
    NgOptimizedImage,
    RouterLinkActive,
    NgTemplateOutlet,
    TranslatePipe,
    ButtonComponent,
    FormsModule,
  ],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  public readonly environment = environment
  public user?: User
  public isOpen: boolean = false

  public constructor(
    private readonly cognitoService: CognitoService,
    private readonly translateService: TranslateService,
    private readonly notificationService: NzNotificationService
  ) {
    cognitoService.user.subscribe((user) => {
      this.user = user
    })
  }

  public logout(): void {
    this.cognitoService.signOut().then(() => {
      this.notificationService.success(
        this.translateService.instant('logoff.message'),
        ''
      )
    })
  }

  public closeMenu(): void {
    this.isOpen = false
  }

  public toggleMenu(): void {
    this.isOpen = !this.isOpen
  }
}
